module.exports = __webpack_public_path__ + "static/media/addImg.c78a59ea.png";